module.exports = __webpack_public_path__ + "img/informer_je_taide.80406d23.png";